import notifyWatcher from '@/modules/notify_watcher';

import SearchBar from '@/modules/search_bar';

import { init } from '@/modules/service_worker';

export default () => {
  init();

  new SearchBar().create();

  notifyWatcher();
};
